import * as React from 'react';
export const billie1Svg = React.forwardRef(function billie1SvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M1.185 12.264c-.426 0-.73-.085-.912-.256C.09 11.836 0 11.564 0 11.193V4.718c0-.381.094-.656.28-.821.185-.166.49-.25.905-.25h3.127c.461 0 .86.025 1.2.075.339.05.64.15.909.293.227.122.43.275.605.462.174.188.307.394.402.618.094.225.14.462.14.715 0 .862-.483 1.493-1.448 1.892 1.27.36 1.902 1.062 1.902 2.105 0 .48-.14.914-.416 1.301a2.43 2.43 0 0 1-1.119.856c-.294.11-.633.187-1.014.23-.381.045-.829.07-1.336.07H1.185Zm.77-7.306v2.226h1.79c.486 0 .864-.04 1.13-.125.266-.084.468-.24.608-.471a.988.988 0 0 0 .165-.553c0-.434-.175-.724-.521-.868-.347-.143-.875-.215-1.588-.215H1.951l.004.006ZM3.99 8.436H1.955v2.516h2.102c1.321 0 1.982-.424 1.982-1.277 0-.434-.171-.749-.514-.946-.342-.196-.853-.293-1.535-.293Zm5.072-4.377c0-.306.283-.559.626-.559h2.902c1.892 0 3.41.737 3.41 2.585 0 1.848-1.518 2.585-3.41 2.585h-2.276v3.19c0 .307-.27.56-.626.56-.357 0-.626-.253-.626-.56v-7.8Zm3.514 3.63c1.235 0 2.176-.405 2.176-1.6 0-1.265-.938-1.59-2.176-1.59h-2.262v3.19h2.262Z',
    }),
  );
});
billie1Svg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var billie1 = {
  category: 'paymentmethod',
  colorable: true,
  name: 'billie1',
  svg: billie1Svg,
};
